/*
 * Ryan O'Dowd
 * 2025-07-18
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({isDarkMode, globalScale, colors}) => {
  return {
    currentRowText: {
      color: isDarkMode ? colors.primaryExtraLight : colors.primary,
    },
    totalsRowText: {
      color: colors.accentDark,
      fontSize: globalScale * 14,
    },
    publishedStatusWrapper: {
      display: 'flex',
      marginBottom: 16,
    },
  };
};

export default getStyles;
